"use strict";

/**
 * Bernie response
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});